module.exports = __webpack_public_path__ + "static/trail-592beec9f84bfbb4f6c90b7b5b16979b.gif";